export const topics = [
  'Procesos',
  'ROI',
  'Calidad',
  'Experiencia',
  'Omnicanalidad'
];

export const items = [
  {
    title: 'Whatsapp para empresas',
    subtitle: 'Canales y atención omnicanal con criterio editorial',
    route: '/whatsapp',
    image: '/images/blog/blog_whatsapp.png',
    heroImage: '/images/blog/blog_whatsapp.png',
    ogImage: '/images/blog/blog_whatsapp.png',
    topics: ['Omnicanalidad', 'Experiencia']
  },
  {
    title: 'Todo Sobre Telefonia',
    subtitle: 'Telefonía integrada y trazable para equipos',
    route: '/telefonia',
    image: '/images/blog/blog_telefonia.png',
    heroImage: '/images/blog/blog_telefonia.png',
    ogImage: '/images/blog/blog_telefonia.png',
    topics: ['Omnicanalidad', 'Procesos']
  },
  {
    title: 'Dispersión Tecnológica',
    subtitle: 'Unificar silos y ordenar información crítica',
    route: '/dispersion-tecnologica',
    image: '/images/blog/blog_dispersion.png',
    heroImage: '/images/blog/blog_dispersion.png',
    ogImage: '/images/blog/blog_dispersion.png',
    topics: ['Procesos', 'Calidad']
  },
  {
    title: 'On-Premise vs On-Cloud',
    subtitle: 'Decisiones con contexto y métricas',
    route: '/on-premise-vs-on-cloud',
    image: '/images/blog/blog_servidores.png',
    heroImage: '/images/blog/blog_servidores.png',
    ogImage: '/images/blog/blog_servidores.png',
    topics: ['ROI', 'Procesos']
  },
  {
    title: 'Inteligencia Artificial Local',
    subtitle: 'IA aplicada con privacidad y control',
    route: '/inteligencia-artificial-local',
    image: '/images/blog/blog_ia.png',
    heroImage: '/images/blog/blog_ia.png',
    ogImage: '/images/blog/blog_ia.png',
    topics: ['Calidad', 'Experiencia']
  },
  {
    title: 'Sistemas de Backup',
    subtitle: 'Trazabilidad y continuidad operativa',
    route: '/sistemas-de-backup',
    image: '/images/blog/blog_backup.png',
    heroImage: '/images/blog/blog_backup.png',
    ogImage: '/images/blog/blog_backup.png',
    topics: ['Calidad', 'Procesos']
  },
  {
    title: 'CRM',
    subtitle: 'Arquitectura comercial, automatización y advisory operativo',
    route: '/crm',
    image: '/images/blog/blog_bitrix24.png',
    heroImage: '/images/blog/blog_bitrix24.png',
    ogImage: '/images/blog/blog_bitrix24.png',
    topics: ['Procesos', 'Experiencia']
  },
  {
    title: 'Omnicanalidad',
    subtitle: 'Un solo número, enrutamiento y trazabilidad para todo el equipo',
    route: '/omnicanalidad',
    image: '/images/blog/blog_omnicanalidad.png',
    heroImage: '/images/blog/blog_omnicanalidad.png',
    ogImage: '/images/blog/blog_omnicanalidad.png',
    topics: ['Omnicanalidad', 'Procesos']
  },
  {
    title: 'Whatsapp-API',
    subtitle: 'Mensajería oficial, auditable e integrada a tus procesos',
    route: '/whatsapp-api',
    image: '/images/blog/blog_whatsapp_api.png',
    heroImage: '/images/blog/blog_whatsapp_api.png',
    ogImage: '/images/blog/blog_whatsapp_api.png',
    topics: ['Omnicanalidad', 'Procesos']
  },
  {
    title: 'Atención médica y trazabilidad clínica',
    subtitle: 'Citas, triaje, historia clínica y recetas con trazabilidad',
    route: '/clinicas',
    image: '/images/blog/blog_citas.png',
    heroImage: '/images/blog/blog_citas.png',
    ogImage: '/images/blog/blog_citas.png',
    topics: ['Procesos', 'Calidad']
  },
  {
    title: 'Reclutamiento sin burocracia',
    subtitle: 'Vacantes, embudo, documentación y onboarding en un solo flujo',
    route: '/reclutamiento-de-personal',
    image: '/images/blog/blog_reclutamiento.png',
    heroImage: '/images/blog/blog_reclutamiento.png',
    ogImage: '/images/blog/blog_reclutamiento.png',
    topics: ['Procesos', 'Experiencia']
  }
];

export const imageSpecs = [
  { key: 'hero', label: 'Portada / Hero', width: 2400, height: 1350, ratio: '16:9' },
  { key: 'card', label: 'Tarjeta / Listado', width: 1200, height: 675, ratio: '16:9' },
  { key: 'og', label: 'Open Graph (redes)', width: 1200, height: 630, ratio: '1.91:1' },
  { key: 'thumb', label: 'Miniatura', width: 600, height: 338, ratio: '16:9' },
  { key: 'square', label: 'Cuadrada (alternativa)', width: 1080, height: 1080, ratio: '1:1' }
];

export const initialHeadline = {
  title: 'Portada Editorial: jugar con contenidos y estructura',
  subtitle: 'Titulares con serifas, columnas claras y divisores finos'
};
